import React from "react";
import { Box, Container } from "@mui/material";
import SlideContent from "./SlideContent"; 
import defaultIndexBg from "../../../assets/centrum_assets/design/index/firstBGS.png";
import defaultIndexBgMin from "../../../assets/centrum_assets/design/index/firstBGmin.png";

const StandardSlide = ({ item, defaultBg, priority = false, index }) => {
    const desktopBg = item.image || defaultBg?.standard_bg || defaultIndexBg;
    const mobileBg = item.mobile_image || defaultBg?.standard_mobile || defaultIndexBgMin;

    const isFirstSlide = index === 0;

    // Custom Breakpoint Variables
    const MAX_MOBILE = "@media (max-width: 675px)";
    const MIN_DESKTOP = "@media (min-width: 676px)";

    return (
        <Box sx={{ position: "relative", width: "100%", height: "100%", overflow: "hidden" }}>
            
            {/* DESKTOP BACKGROUND - Visible only from 676px up */}
            <Box 
                component="img" 
                src={desktopBg} 
                sx={{ 
                    width: "100%", 
                    height: "100%", 
                    objectFit: "cover", 
                    display: "none", 
                    [MIN_DESKTOP]: { display: "block" }
                }} 
            />
            
            {/* MOBILE & TABLET LAYOUT - Visible only at 675px and below */}
            <Box sx={{ 
                display: "none", 
                flexDirection: "column", 
                height: "100%",
                [MAX_MOBILE]: { display: "flex" } 
            }}>
                <Box 
                    component="img" 
                    src={mobileBg} 
                    sx={{ 
                        width: "100%", 
                        objectFit: "cover", 
                        flexShrink: 0,
                        // Height control for the first slide on small screens
                        ...(isFirstSlide && {
                            [MAX_MOBILE]: {
                                height: "40vh",
                                objectFit: "cover" 
                            }
                        })
                    }} 
                />
                
                <Box sx={{ 
                    flex: 1, 
                    display: "flex", 
                    alignItems: "center", 
                    px: 4, 
                    py: 4, 
                    color: "#002349" 
                }}>
                    <Container maxWidth="md" sx={{ px: 0 }}>
                        <SlideContent item={item} isMobile={true} />
                    </Container>
                </Box>
            </Box>

            {/* DESKTOP CONTENT - Overlay visible only from 676px up */}
            <Box sx={{
                position: "absolute", 
                top: "50%", 
                left: "5%", 
                transform: "translateY(-50%)",
                width: "45%", 
                color: "#002349", 
                zIndex: 10,
                display: "none",
                [MIN_DESKTOP]: { display: "block" }
            }}>
                <SlideContent item={item} isMobile={false} />
            </Box>
        </Box>
    );
};

export default StandardSlide;